export default "__VITE_ASSET__j6aSKe8E__"